import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.timers.js";
import { defineComponent } from "vue";
import ButtonBasic from "@/components/form/ButtonBasic.vue";
export default defineComponent({
  name: "faqComponent",
  components: {
    ButtonBasic: ButtonBasic
  },
  props: {
    name: String
  },
  watch: {
    faqSearch: "checkIfDoneTyping"
  },
  mounted: function mounted() {
    console.log("<<<<<<<<< faqComponent mounted >>>>>>>>>");
  },
  data: function data() {
    return {
      faqSearch: "",
      isSearching: false,
      faqSearchTerms: [],
      faqs: [{
        subject: "subscription",
        question: "Can I opt-out of the subscription at any time?",
        answer: "Yes! There is no contract and you can cancel at any time."
      }, {
        subject: "subscription",
        question: "How can I delete my data?",
        answer: "Send an email from the email address you used to sign up to ".concat(this.$store.state.supportEmail, " and request to delete data your data and we will process this request within 24 hours.")
      }, {
        subject: "features",
        question: "What do memories do and do I have to use that feature?",
        answer: "You can toggle to store or use memories (either or both) so memories do not have to be used. Memories allow you the ability to have your AIVitar store your conversations to be used later. For example, if you tell the AIVitar you have two kids aged 2, and 6 named John and Mary, with memories the AIVItar will be able to recall this information and use it in future conversations."
      }, {
        subject: "features",
        question: "What is context and do I have to use it?",
        answer: "Context allows your AIVitar to remember the last few questions and answers. This allows the AIVitar to have a better understanding of the conversation. For example, if you ask the AIVitar \"What is the tallest building in the world?\" and the AIVitar responds \"The tallest building in the world is the Burj Khalifa in Dubai.\", then you ask \"How tall is it?\" the AIVitar will remember the last question and answer and be able to respond with \"The Burj Khalifa is 2,717 feet tall.\". Without context on the AIVitar will have no idea what you are talking about since it has no understanding of the conversation.",
        images: ["/assets/web/faq/features_context.webp"]
      }, {
        subject: "features",
        question: "Will context work after closing the application ?",
        answer: "Yes! Turning on the context at any time will allow the AIVitar to remember the last few questions and answers.",
        images: ["/assets/web/faq/features_context.webp"]
      }, {
        subject: "features",
        question: "Will the AIVitar talk when messaging it?",
        answer: "Messaging allows for you to silently communicate with the AIVItar. However, there's a button under each text box that allows you to have the text spoken by the aivitar.",
        images: ["/assets/web/faq/messaging_play.webp"]
      }, {
        subject: "features",
        question: "How can I email responses from the AIVitar?",
        answer: "Yes! Whether verbally spoken or when messaging, all responses show up in the messaging tab and you can click on the email icon which will open the content in your native device's email program.",
        images: ["/assets/web/faq/messaging_email.webp"]
      }, {
        subject: "features",
        question: "How can I email responses from the AIVitar?",
        answer: "Yes! Whether verbally spoken or when messaging, all responses show up in the messaging tab and you can click on the email icon which will open the content in your native device's email program.",
        images: ["/assets/web/faq/messaging_email.webp"]
      },
      // features_talk_toggle.webp
      {
        subject: "features",
        question: "How can I turn off memory?",
        answer: "Memory can be turned off directly on the AIVitar control bar. Clicking on this toggles between use memory and store next conversation for memory, use off and store on, use on and store off or all off.",
        images: ["/assets/web/faq/features_memory.webp"]
      }, {
        subject: "features",
        question: "How do I turn on continuous mode and what is it?",
        answer: "Clicking on the talk icon toggles between single talk conversation where if someone stops talking it turns off the mic and continuous mode. Continuous mode allows you to have the AIVitar continuously listen for your voice. This is useful if you want to have a conversation with the AIVitar without having to click the microphone button each time. To turn on continuous mode click on the microphone button and hold it down. To turn it off click on the microphone button and release it.",
        images: ["/assets/web/faq/features_talk_toggle.webp"]
      }, {
        subject: "features",
        question: "How do I turn off context mode and what is it?",
        answer: "Context ",
        images: ["/assets/web/faq/features_talk_toggle.webp"]
      }, {
        subject: "features",
        question: "How can I change my AIVitar Settings?",
        answer: "Some settings can be found on each page of the app but accessing more customized settings can be found by <ul><li>1. Clicking the menu icon</li><li>2. Clicking 'AIVitar Settings'</li></ul>",
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_avatarsettings.webp"]
      }, {
        subject: "features",
        question: "How do I switch to messaging mode?",
        answer: "To swith to messaging mode click on the message icon on the bottom bar.",
        images: ["/assets/web/faq/bar_message.webp"]
      }, {
        subject: "features",
        question: "How do I switch to Video mode?",
        answer: "To swith to video mode click on the video icon on the bottom bar.",
        images: ["/assets/web/faq/bar_video.webp"]
      }, {
        subject: "features",
        question: "How do I switch to map view?",
        answer: "To swith to map mode click on the map icon on the bottom bar.",
        images: ["/assets/web/faq/bar_map.webp"]
      }, {
        subject: "features",
        question: "How do I switch to to-do view?",
        answer: "To swith to todo mode click on the todo icon on the bottom bar.",
        images: ["/assets/web/faq/bar_todo.webp"]
      }, {
        subject: "features",
        question: "How do I switch to notes view?",
        answer: "To swith to notes mode click on the notes icon on the bottom bar.",
        images: ["/assets/web/faq/bar_notes.webp"]
      }, {
        subject: "features",
        question: "How do I add a new note with my voice?",
        answer: "When talking to the AIVitar, you can say \"add a note\" or \"add a new note\", it will then ask you what you want to add and you can simply talk to the AIVitar and it will be added.",
        images: []
      }, {
        subject: "features",
        question: "How do I add a todo item to my list that has already been added but is checkedoff?",
        answer: "When talking to the AIVitar, you can simply tell it \"Add 'buy grocieries to my todo list' \" and the AIVitar will find that item is already on the list and uncheck it.",
        images: []
      }, {
        subject: "features",
        question: "When adding a todo item to my list how can I prevent it from adding duplicates?",
        answer: "Your AIVItar is smart enough to know if you are adding a duplicate item to your todo list. If you add an item that is already on the list it will simply uncheck it. If it is not completed, it will tell you it is already on the list and that it is not marked as completed yet.",
        images: []
      }, {
        subject: "features",
        question: "How can I search for nearby resturants with my voice?",
        answer: "Simply say \"show me resturants near me\" and the AIVitar will show you a map with resturants near you. or you can say \"find me chinese resturants near me\" and it will show you a map with chinese resturants near you.",
        images: []
      }, {
        subject: "features",
        question: "How accurate is the data from the AIVitar?",
        answer: "We're working on improving the data and most of the time it should provide accurate information. However, please do your own research for vital information. We are not responsible for any incorrect information provided by the AIVitar.",
        images: []
      }, {
        subject: "features",
        question: "How accurate is the chart data from the AIVitar?",
        answer: "We're working on improving the data and most of the time it should provide accurate information. However, please do your own research for vital information. We are not responsible for any incorrect information provided by the AIVitar.",
        images: []
      }, {
        subject: "features",
        question: "Is AIVitar made from images of real people?",
        answer: "No, AIVitar is 100% generated by a neural network. It is not made from images of real people.",
        images: []
      }, {
        subject: "features",
        question: "Is any of the responses provided by a person or is it generated by artificial intelligence(ai)?",
        answer: "Nearly 100% of messages you recieve are generated by A.I. There are some system messages and other messages that might be added to provide information and utility. These use cases are very few but when they are added we try to make them as authentic and naturally sounding as possible.",
        images: []
      }, {
        subject: "features",
        question: "Is any of the responses provided by a person or is it generated by artificial intelligence(ai)?",
        answer: "Nearly 100% of messages you recieve are generated by A.I. There are some system messages and other messages that might be added to provide information and utility. These use cases are very few but when they are added we try to make them as authentic and naturally sounding as possible.",
        images: []
      }, {
        subject: "features",
        question: "How do I add a new todo item with my voice?",
        answer: "When talking to the AIVitar, you can say \"Add 'buy grocieries to my todo list' \" and the AIVitar will add \"buy grocieries\" to to your todo list.",
        images: []
      }, {
        subject: "subscription",
        question: "Can I get my data if you go out of business?",
        answer: "Yes! We know that you might need this data to recreate or transfer it later on in the event that we go out of business at some point (it's happened before to other people using chatbots and they were sad). So if we somehow have to close down we will allow you to request data for up to 90 days after the service is turned off so you do not lose it. This will be a service provided at free of charge.",
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_avatarsettings.webp"]
      }, {
        subject: "subscription",
        question: "How can I cancel my billing subscription?",
        answer: "Cancelling is easy here's how you do it. <ul><li>1. Clicking the menu icon</li><li>2. Click  'Billing'</li><li>3. Click  'Manage My Account At Stripe'</li><li>4. Log in (likely they will send you an email you have to then open from email client). Then cancel from that URL they send you via email.</li></ul>  <p>However, we would hate to see you go! If we can help you change your mind (maybe you need a feature we are missing?) please first reach out <a href=\"mailto:".concat(this.$store.state.supportEmail, "\">").concat(this.$store.state.supportEmail, "</a> and let's talk! We're dedicated to our users and their experience with our platform.</p>"),
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_billing.webp", "/assets/web/faq/billing_manage_account.webp"]
      }, {
        subject: "documents",
        question: "How can I view the Terms of Service?",
        answer: "If you are in the app logged in: <ul><li>1. click the settings menu at the top</li><li>2. click Policies & Terms</li><li>3. click Terms of Service..</li></ul>. From the website, if you are not logged in, click on Terms of Service from the footer. ",
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_policies_and_terms.webp", "/assets/web/faq/menu_terms.webp"]
      }, {
        subject: "documents",
        question: "How can I view the Privacy Policy?",
        answer: "If you are in the app logged in: <ul><li>1. click the settings menu at the top</li><li>2. click Policies & Terms</li><li>3. click Privacy Policy.</li></ul>. From the website, if you are not logged in, click on Privacy Policy from the footer. ",
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_policies_and_terms.webp", "/assets/web/faq/menu_privacy_policy.webp"]
      }, {
        subject: "documents",
        question: "How can I view the Privacy Policy?",
        answer: "If you are in the app logged in: <ul><li>1. click the settings menu at the top</li><li>2. click Policies & Terms</li><li>3. click Cookie Policy.</li></ul>. From the website, if you are not logged in, click on Cookie Policy from the footer. ",
        images: ["/assets/web/faq/settings_menu.webp", "/assets/web/faq/menu_policies_and_terms.webp", "/assets/web/faq/menu_cookie_policy.webp"]
      }, {
        subject: "features",
        question: "What languages does the AIVitar support?",
        answer: "Speaking or Writing messages to AIVitar works with <b>over 60 languages!</b> However, the speech to text functionality is limited to your device's capabilities and settings since it uses native device speech to text. Texting should work for all of them but they have not all been tested. Please let us know your experience with languages other than english. If you wish to have additional languages supported for in-app langes please contact us via <a href=\"mailto:".concat(this.$store.state.supportEmail, ">").concat(this.$store.state.supportEmail, "</a>. If using Google Chrome's speech recognition service for your speech to text for instance it can understand most of them. As for the AI engine, here's the list of known languages it understands. <ul>\n  <li>English</li>\n  <li>Spanish</li>\n  <li>French</li>\n  <li>German</li>\n  <li>Chinese</li>\n  <li>Japanese</li>\n  <li>Korean</li>\n  <li>Russian</li>\n  <li>Italian</li>\n  <li>Dutch</li>\n  <li>Portuguese</li>\n  <li>Arabic</li>\n  <li>Turkish</li>\n  <li>Swedish</li>\n  <li>Danish</li>\n  <li>Norwegian</li>\n  <li>Finnish</li>\n  <li>Polish</li>\n  <li>Czech</li>\n  <li>Hungarian</li>\n  <li>Greek</li>\n  <li>Hebrew</li>\n  <li>Indonesian</li>\n  <li>Vietnamese</li>\n  <li>Thai</li>\n  <li>Hindi</li>\n  <li>Bengali</li>\n  <li>Urdu</li>\n  <li>Tamil</li>\n  <li>Telugu</li>\n  <li>Marathi</li>\n  <li>Persian</li>\n  <li>Romanian</li>\n  <li>Bulgarian</li>\n  <li>Serbian</li>\n  <li>Croatian</li>\n  <li>Slovak</li>\n  <li>Slovenian</li>\n  <li>Ukrainian</li>\n  <li>Estonian</li>\n  <li>Latvian</li>\n  <li>Lithuanian</li>\n  <li>Georgian</li>\n  <li>Armenian</li>\n  <li>Azerbaijani</li>\n  <li>Uzbek</li>\n  <li>Kazakh</li>\n  <li>Irish</li>\n  <li>Welsh</li>\n  <li>Icelandic</li>\n  <li>Albanian</li>\n  <li>Macedonian</li>\n  <li>Maltese</li>\n  <li>Swahili</li>\n  <li>Afrikaans</li>\n  <li>Zulu</li>\n  <li>Yoruba</li>\n  <li>Somali</li>\n  <li>Filipino</li>\n  <li>Khmer</li>\n  <li>Lao</li>\n  <li>Burmese</li>\n  <li>Mongolian</li>\n</ul>"),
        images: ["/assets/web/faq/features_languages.webp"]
      }],
      doneTyping: false,
      typingTimer: null,
      hideNonSearch: false,
      screenshots: [{
        image: "/assets/web/screenshots/2.webp",
        alt: "some alt",
        caption: "Conversational"
      }, {
        image: "/assets/web/screenshots/3.webp",
        alt: "So many exciting features that really bringing these avatars to life.",
        caption: "Animated"
      }, {
        image: "/assets/web/screenshots/10.webp",
        alt: "Message your new friend and get to know them.",
        caption: "Messaging"
      }, {
        image: "/assets/web/screenshots/5.webp",
        alt: "some alt",
        caption: "Live"
      }, {
        image: "/assets/web/screenshots/4.webp",
        alt: "some alt",
        caption: "Helpful"
      }, {
        image: "/assets/web/screenshots/6.webp",
        alt: "some alt",
        caption: "Selection"
      }, {
        image: "/assets/web/screenshots/1.webp",
        alt: "some alt",
        caption: "Exciting"
      }, {
        image: "/assets/web/screenshots/7.webp",
        alt: "some alt",
        caption: "Personal"
      }, {
        image: "/assets/web/screenshots/9.webp",
        alt: "some alt",
        caption: "Feature Rich"
      }
      // ,{
      //   image: '/assets/web/screenshots/9.webp',
      //   alt: 'some alt',
      //   caption: 'some caption'
      // }
      ],
      supportedLanguages: ["English", "Spanish", "French", "German", "Chinese", "Japanese", "Korean", "Russian", "Italian", "Dutch", "Portuguese", "Arabic", "Turkish", "Swedish", "Danish", "Norwegian", "Finnish", "Polish", "Czech", "Hungarian", "Greek", "Hebrew", "Indonesian", "Vietnamese", "Thai", "Hindi", "Bengali", "Urdu", "Tamil", "Telugu", "Marathi", "Persian", "Romanian", "Bulgarian", "Serbian", "Croatian", "Slovak", "Slovenian", "Ukrainian", "Estonian", "Latvian", "Lithuanian", "Georgian", "Armenian", "Azerbaijani", "Uzbek", "Kazakh", "Irish", "Welsh", "Icelandic", "Albanian", "Macedonian", "Maltese", "Swahili", "Afrikaans", "Zulu", "Yoruba", "Somali", "Filipino", "Khmer", "Lao", "Burmese", "Mongolian"]
    };
  },
  methods: {
    closeModal: function closeModal() {
      var modalCpy = this.modal;
      modalCpy.open = false;
      this.modal = modalCpy;
    },
    openModal: function openModal(type) {
      var modalCpy = this.modal;
      if (type === "faq") {
        modalCpy.title = "F.A.Q.";
        modalCpy.subtitle = "Frequently Asked Questions";
      }
      if (type === "register") {
        modalCpy.title = "Register";
        modalCpy.subtitle = "Register for an account";
      }
      modalCpy.open = true;
      this.modal = modalCpy;
    },
    checkIfDoneTyping: function checkIfDoneTyping() {
      var _this = this;
      // If faqSearch is empty, consider the user done typing
      if (!this.faqSearch) {
        this.isSearching = false;
        this.doneTyping = true;
        this.hideNonSearch = false;
      } else {
        this.doneTyping = false;

        // After each key press, clear the timer if it has already been set.
        clearTimeout(this.typingTimer);

        // If the timer is longer than 1 second, update doneTyping to true and make the search request
        this.typingTimer = setTimeout(function () {
          _this.doneTyping = true;
          if (_this.faqSearch) {
            _this.extractKeywords();
            _this.hideNonSearch = true;
          }
          _this.isSearching = false;
        }, 1000);
      }
    },
    containsWords: function containsWords(faq) {
      if (this.faqSearch && this.doneTyping && this.faqSearchTerms.length > 0) {
        var question = faq.question.toLowerCase();
        var answer = faq.answer.toLowerCase();
        var faqSearchTerms = this.faqSearchTerms;
        //  return true if any of the words in the array are in the string for answer or question
        if (Array.isArray(faqSearchTerms) && question && answer) {
          return faqSearchTerms.some(function (word) {
            return question.includes(word) || answer.includes(word);
          });
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    extractKeywords: function extractKeywords() {
      // get array of keywords from faqSearch b()y sperating by space
      var keywords = this.faqSearch.toLowerCase().split(" ");
      if (Array.isArray(keywords)) {
        this.faqSearchTerms = keywords;
      } else {
        this.faqSearchTerms = this.faqSearch;
      }
    }
  }
});